<template>
  <b-col v-if="value">
    <template v-if="!hideName">
      <b>{{name || 'Location'}}</b><br>
    </template>
    <template v-if="Array.isArray(location) && location.length">
      <div>
        <span
          class="skill-tag mr-1 mt-1"
          :style="{ backgroundColor: backgroundColor || '#eee' }"
          v-for="loc in location"
          :key="loc.id"
        >{{loc.name}} {{ loc.countryName ? `(${loc.countryName})` : '' }}</span><br>
        <span v-if="remote" class="text-muted">Remote</span>
      </div>
    </template>
    <template v-else-if="Array.isArray(location) && !location.length">
      <span class="text-muted">no location selected</span><span v-if="remote" class="text-muted">, Remote</span>
    </template>
    <template v-else-if="typeof value === 'string'">
      <span>{{ value }}</span>
    </template>
    <template v-else>
      <span class="text-muted">{{location.name}} {{ location.countryName ? `(${location.countryName})` : '' }}</span><span v-if="remote" class="text-muted">, Remote</span>
    </template>
  </b-col>
</template>

<script>
export default {
  name: 'JobLocationShow',
  props: {
    name: {
      type: String,
    },
    value: {
      default: () => null,
    },
    backgroundColor: {
      type: String,
      default: '#eee',
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    location() {
      const { value } = this;
      return value && value.location ? value.location : {};
    },
    remote() {
      const { value } = this;
      return value && value.remote ? value.remote : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.skill-tag {
  display: inline-block;
  font-size: 13px;
  padding: 3px 6px;
  border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/LocationShow.vue